import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

export interface ICoachCounts {
    newAssignments: number;
    pendingApproval: number;
    pendingFollowUp: number;
    declinedCs: number;
    optedOut: number;
    all: number;
}

interface IRetVal {
    loading: boolean;
    error: string;
    counts: ICoachCounts;
}

const defaultCounts: ICoachCounts = {
    newAssignments: 0,
    pendingApproval: 0,
    pendingFollowUp: 0,
    declinedCs: 0,
    optedOut: 0,
    all: 0
};

function useCoachCounts(contactId: number, refreshKey: number = 0): IRetVal {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [counts, setCounts] = useState<ICoachCounts>(defaultCounts);

    const { dispatch } = useAppHookContext();

    useEffect(() => {
        if (!contactId) {
            return;
        }

        setLoading(true);
        setError('');

        const fetchData = async () => {
            const config: IGet = {
                url: `${__API__}/microsite/coach/action-center/counts?coachContactId=${contactId}`
            };

            try {
                const response = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.success) {
                    setCounts(response.data.results);
                } else {
                    setError('Unable to load coach counts');
                    setCounts(defaultCounts);
                }
            } catch (err) {
                setCounts(defaultCounts);
                setError(err?.message ?? 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [contactId, refreshKey]);

    return { loading, error, counts };
}

export default useCoachCounts;
